module.exports = __webpack_public_path__ + "img/ChinaJoy.3203b14b.png";